





















import Vue from 'vue';
import Component from 'vue-class-component';
import AdComment from '@/components/User/AdComment.vue';
import {Comment} from '@/types/Comment';
import {Prop, Watch} from 'vue-property-decorator';
import NewCommentForm from '@/components/User/NewCommentForm.vue';
import {getComments} from '@/clients/UserCommentsClient';
import LoadingPanel from '@/components/LoadingPanel.vue';

@Component({
  name: 'AdComments',
  components: {LoadingPanel, NewCommentForm, AdComment},
})
export default class AdComments extends Vue {
  @Prop({type: String, required: true}) readonly externalId!: string;

  private comments: Array<Comment> = [];
  private isLoading = false;

  @Watch('$route', {immediate: true}) onRouteChange() {
    this.refresh();
  }

  private refresh(): void {
    this.isLoading = true;
    getComments(this.externalId).then((response) => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return response.json();
    }).then(data => {
      this.comments = data.comments;
    }).finally(() => {
      this.isLoading = false;
    });
  }
}
